/* nb-article-toc.js
   Builds a sticky table-of-contents for nb-article from h2/h3 headings inside
   .nb-art__body. Hides itself if the article has fewer than 3 headings.
   Tracks active heading via IntersectionObserver.
*/
(function () {
  'use strict';

  function init() {
    var article = document.querySelector('.nb-art[data-toc-enabled="true"]');
    if (!article) return;

    var body = article.querySelector('[data-nb-article-body]');
    var nav = article.querySelector('[data-nb-toc]');
    var list = article.querySelector('[data-nb-toc-list]');
    var sidebar = article.querySelector('[data-nb-toc-sidebar]');
    if (!body || !nav || !list) return;

    var headings = Array.prototype.slice.call(
      body.querySelectorAll('h2, h3')
    );

    if (headings.length < 3) {
      if (sidebar) sidebar.setAttribute('aria-hidden', 'true');
      return;
    }

    var usedSlugs = {};
    function slugify(text) {
      var slug = (text || '')
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      if (!slug) slug = 'section';
      var base = slug;
      var n = 2;
      while (usedSlugs[slug]) {
        slug = base + '-' + n;
        n += 1;
      }
      usedSlugs[slug] = true;
      return slug;
    }

    var fragment = document.createDocumentFragment();

    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent);
      } else {
        usedSlugs[heading.id] = true;
      }

      var li = document.createElement('li');
      li.className = 'nb-art__toc-item nb-art__toc-item--' + heading.tagName.toLowerCase();

      var a = document.createElement('a');
      a.className = 'nb-art__toc-link';
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      a.dataset.tocTarget = heading.id;

      a.addEventListener('click', function (event) {
        event.preventDefault();
        var target = document.getElementById(heading.id);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) {
          history.replaceState(null, '', '#' + heading.id);
        }
      });

      li.appendChild(a);
      fragment.appendChild(li);
    });

    list.appendChild(fragment);
    nav.removeAttribute('hidden');
    if (sidebar) sidebar.setAttribute('aria-hidden', 'false');

    var links = Array.prototype.slice.call(
      list.querySelectorAll('.nb-art__toc-link')
    );
    var linkById = {};
    links.forEach(function (l) {
      linkById[l.dataset.tocTarget] = l;
    });

    function setActive(id) {
      links.forEach(function (l) {
        if (l.dataset.tocTarget === id) {
          l.classList.add('is-active');
        } else {
          l.classList.remove('is-active');
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      setActive(headings[0].id);
      return;
    }

    var headerOffset = 0;
    var rootStyles = getComputedStyle(document.documentElement);
    var headerVar = rootStyles.getPropertyValue('--nb-header-h').trim();
    if (headerVar) {
      headerOffset = parseInt(headerVar, 10) || 80;
    } else {
      headerOffset = 80;
    }

    var visible = {};
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible[entry.target.id] = entry.boundingClientRect.top;
          } else {
            delete visible[entry.target.id];
          }
        });

        var ids = Object.keys(visible);
        if (ids.length === 0) {
          var scrollTop = window.scrollY || window.pageYOffset;
          var lastAbove = null;
          headings.forEach(function (h) {
            var top = h.getBoundingClientRect().top + scrollTop;
            if (top - headerOffset - 32 <= scrollTop) {
              lastAbove = h.id;
            }
          });
          if (lastAbove) setActive(lastAbove);
          return;
        }

        ids.sort(function (a, b) {
          return visible[a] - visible[b];
        });
        setActive(ids[0]);
      },
      {
        rootMargin: '-' + (headerOffset + 24) + 'px 0px -55% 0px',
        threshold: [0, 1]
      }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
